
export { default as applySpec } from "./applySpec.js"
export { default as defaultTo } from "./defaultTo.js"
export { default as equals } from "./equals.js"
export { default as filter } from "./filter.js"
export { default as head } from "./head.js"
export { default as pick } from "./pick.js"
export { default as pipe } from "./pipe.js"
export { default as prop } from "./prop.js"